export const CHARACTER_LIMIT = 1000;

export type AnimationState = "full-screen" | "original" | "popping" | "popping-back";

export type PlayingState = "idle" | "loading" | "paused" | "playing";
